export default {"src":"/_next/static/image/public/images/flags/flag_970.042d66adb3cbb84f81acfe599b9bff3c.svg","height":16,"width":24};